module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step02_3c6acf744e8cfe37411a886686445629.png";